import { HStack, Text } from '@chakra-ui/react'
import { FiClock } from 'react-icons/fi'

export const StudyHoursTotal = ({ total }: { total: number }) => (
  <HStack
    bg="green.50"
    border="1px solid"
    borderColor="green.100"
    borderRadius="xl"
    align={{ base: 'start', md: 'center' }}
    flexDirection={{ base: 'column', md: 'row' }}
    justify="space-between"
    p={{ base: 5, md: 6 }}
  >
    <HStack spacing={4}>
      <FiClock aria-hidden color="#18864b" size={36} />
      <Text fontSize="lg" fontWeight="bold">
        Total study this month
      </Text>
    </HStack>
    <Text
      color="green.600"
      fontSize="xl"
      fontWeight="bold"
      whiteSpace="nowrap"
    >
      {total} hours
    </Text>
  </HStack>
)
